import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MyBetsConfig, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { EpcotConfigService } from '../../../common/epcot-config.service';
import { MyBetsBet } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsUtilService } from '../../services/my-bets-util.service';

@Component({
    selector: 'ms-my-bets-multi-bet-betbuilder-title',
    templateUrl: 'my-bets-multi-bet-betbuilder-title.html',
    styleUrls: ['my-bets-multi-bet-betbuilder-title.scss', '../../styles/original-odds.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MyBetsBetbuilderTitleComponent {
    bet = input.required<MyBetsBet>();

    isEpcotEnabled = false;

    betCancelledAndPending = computed(() => {
        return this.myBetsConfig.enableSGPRepricedOdds && !!this.bet().ogpRepricingInfo?.isPending;
    });

    betCancelledAndRepriced = computed(() => {
        return this.myBetsConfig.enableSGPRepricedOdds && !!this.bet().ogpRepricingInfo?.odds;
    });

    constructor(
        public sitecoreMyBets: SitecoreMyBetsConfig,
        public myBetsConfig: MyBetsConfig,
        private epcotConfigService: EpcotConfigService,
        public myBetsUtilService: MyBetsUtilService,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled();
    }
}
